import { PopoverContent as Content } from '@components/ui/popover'
import type React from 'react'

export default function PopoverContent({
  children,
}: {
  children: React.ReactNode
}): JSX.Element {
  return <Content>{children}</Content>
}
